"use client";

import { useLocale } from "next-intl";
import { useCallback, useState } from "react";
import { convAILanguages, type LanguageMetadata } from "@mw/shared/languagesAndAccents";

function getConvAILanguage(locale: string) {
  const exactMatch = convAILanguages.find(l => l.value === locale);
  if (exactMatch) return exactMatch;

  const prefixMatch = convAILanguages.find(l => l.value.startsWith(locale + "-") || locale.startsWith(l.value));
  if (prefixMatch) return prefixMatch;

  return convAILanguages.find(l => l.value === "en") ?? convAILanguages[0];
}

export function useConvAILanguage() {
  const locale = useLocale();
  const [language, setLanguage] = useState<LanguageMetadata>(() => getConvAILanguage(locale));

  const setLanguageByLocale = useCallback((nextLocale: string) => {
    setLanguage(getConvAILanguage(nextLocale));
  }, []);

  return { language, setLanguage, setLanguageByLocale };
}
